import { ApartmentStatus } from "../const";
import { cn } from "@/core/helpers/cn";

export function ApartmentStatusDot({
  status,
  className,
}: {
  status: ApartmentStatus;
  className: string;
}) {
  const bgColor = status === ApartmentStatus.Unlocked ? "bg-[#84ff9733]" : "bg-[#ff4e4e33]";
  const dotColor = status === ApartmentStatus.Unlocked ? "bg-[#84ff97]" : "bg-[#ff4e4e]";

  return (
    <div className={className}>
      <div className={cn("relative rounded-full w-[14px] h-[14px]", bgColor)}>
        <div
          className={cn(
            "top-1/2 left-1/2 absolute rounded-full w-[6px] h-[6px] -translate-x-1/2 -translate-y-1/2",
            dotColor,
          )}
        />
      </div>
    </div>
  );
}
